import React, { PureComponent, Fragment } from 'react';
import { CSSTransition } from "react-transition-group";
import { push } from 'connected-react-router';
import { compose } from "redux";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import * as _ from "lodash";
import i18n from '../../../../../i18n/index';

import Icon from '../../../../icons/Icon';
import * as styles from './style.css';
import history from 'src/store';
import Div100vh from "../../../../uq-ui/components/div-100";
import Select from "../../../../uq-forms/components/select";

import { currentUserInfoSelector } from 'src/app/modules/auth/store/auth-user/selectors';
import { sidebarVisibilitySelector } from '../../../store/selectors';
import { logout } from 'src/app/modules/auth/store/auth-user/actions';
import { setSidebarVisibility } from "../../../store/actions";
import { updateProfileInfo } from 'src/app/modules/account/store/actions';
import { getTranslationLang } from '../../../../../i18n/index';
import { createLlamaStateSelector } from '../../../../stickers/store/create-llama/selectors';
import { isMemorialType } from "../../../../../modules/stickers/store/sticker-show/selectors";
import UserAgent from '../../../../uq-ui/helpers/express-useragent';

const languages = { en: 'English', he: 'Hebrew' };

class Sidebar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHelpOpened: false,
      isSelectLanguageShow: false,
    };
  }

  componentDidMount() {
    const userAgent = new UserAgent().parse(navigator.userAgent);
    if (userAgent.isDesktop) { this.setState({ isDesktop: true }) }
  }

  onLoginPress = () => {
    const { createState, goLogin, setSidebarVisibility } = this.props;
    if (createState.scannedSticker && createState.scannedSticker.id && localStorage) {
      localStorage.setItem('confStickerId', createState.scannedSticker.id);
    }
    goLogin();
    setSidebarVisibility(false);
  }
  onLogoutPress = () => {
    this.props.logout();
  }
  toggleHelp = () => {
    this.setState({ isHelpOpened: !this.state.isHelpOpened})
  }
  onClosePress = () => {
    this.setState({
      isHelpOpened: false,
    })
    this.props.setSidebarVisibility(false);
  }
  onLanguageChanged = (event) => {
    const lang = event.target.value;
    localStorage && localStorage.setItem('lang', lang);
    this.props.updateUserLang(lang);
    i18n.changeLanguage(lang);
  };
  renderAvatar() {
    const { avatar_thumbnail } = this.props.currentUserInfo;
    if (avatar_thumbnail) {
      return (
        <div className={styles.avatarContainer}>
          <img className={styles.profileAvatar} src={avatar_thumbnail.source}/>
        </div>
      )
    } else {
      return (<Icon name="DefaultSettingsAvatar" width="50px" height="50px"/>);
    }
  }
  renderProfileInfo() {
    if (!_.isEmpty(this.props.currentUserInfo)) {
      const { display_name, email } = this.props.currentUserInfo;
      return (
        <div style={{ margin: '0 15px' }}>
          <div className={`${styles.primaryText} font-text`}>{display_name}</div>
          <div className={`${styles.secondaryText} font-text`}>{email}</div>
        </div>
      );
    } else {
      return (
        <div style={{ margin: '0 15px', cursor: 'default' }}
             onClick={this.onLoginPress}>
          <div className={`${styles.primaryText} font-text`}>{this.props.t('letsStart')}</div>
        </div>
      );
    }
  }
  renderCloseButton() {
    return (
      <Icon name={ this.props.isMemorialTheme ? 'CloseSidebarDark' : 'CloseSidebar' } 
            width='12.38px' 
            height='13.99px' 
            className={styles.closeBtn}
            onClick={this.onClosePress}/>
    );
  }

  renderHelp() {
    const isRTL = i18n.dir() === 'rtl';
    const arrowStyle = isRTL ? { transform: 'rotate(0deg)'} : {};
    const linkParam = isRTL ? '?lang=he' : '';
    return (
      <div>
        <div className={styles.titleContainer}>
          <div className={`${ this.props.isMemorialTheme ? styles.title_memorial : styles.title } font-text`}>{this.props.t('help')}</div>
          { this.renderCloseButton() }
        </div>
        <div className={styles.languageContainer}>
          <a href={`https://www.llama.im/contact${linkParam}`} 
             target="_blank" 
             className={`${styles.primaryText} font-text`}>
              {this.props.t('contactUs')}
          </a>
        </div>
        <div className={styles.languageContainer}>
          <a href={`https://www.llama.im/privacy-policy${linkParam}`} 
             target="_blank" 
             className={`${styles.primaryText} font-text`}>
              {this.props.t('privacyPolicy')}
          </a>
        </div>
        <div className={styles.languageContainer}>
          <a href={`https://www.llama.im/terms-of-use${linkParam}`} 
             target="_blank" 
             className={`${styles.primaryText} font-text`}>
              {this.props.t('termsOfUse')}
          </a>
        </div>
        <div className={styles.loginContainer}
            onClick={this.toggleHelp}>
          <Icon name="Arrow" className={styles.backArrow} style={arrowStyle}/>          
          <div className={`${styles.loginText} font-text`}>{this.props.t('back')}</div>
        </div>
      </div>
    );
  }

  renderLogin() {
    if (!_.isEmpty(this.props.currentUserInfo)) {
      return (
        <div className={styles.loginContainer}
             onClick={this.onLogoutPress}>
          <Icon name="Logout" allowRTL={true}/>
          <div className={`${styles.loginText} font-text`}>{this.props.t('logout')}</div>
        </div>
      );
    } else {
      return (
        <div className={styles.loginContainer}
             onClick={this.onLoginPress}>
          <Icon name="Login" allowRTL={true}/>
          <div className={`${styles.loginText} font-text`}>{this.props.t('login')}</div>
        </div>
      );
    }
  }

  renderMain() {
    const isRTL = i18n.dir() === 'rtl';
    const arrowStyle = isRTL ? { transform: 'rotate(180deg)'} : {};
    const lang = getTranslationLang();
    return (
      <div>
        <div className={styles.titleContainer}>
          <div className={`${ this.props.isMemorialTheme ? styles.title_memorial : styles.title } font-text`}>{this.props.t('settings')}</div>
          { this.renderCloseButton() }
        </div>
        <div className={styles.profileContainer}>
          { this.renderAvatar() }
          { this.renderProfileInfo() }
        </div>
        <div className={styles.languageContainer}
              onClick={this.onLanguageSelectShow}>

          <div className={`${styles.primaryText} font-text`}>{this.props.t('language')}</div>
          <select name="language" 
                  defaultValue={lang} 
                  className={`${styles.secondaryText} ${styles.languageSelect} font-text`}
                  onChange={this.onLanguageChanged}>
            {Object.keys(languages).map(v => <option value={v} key={v}>{this.props.t(v)}</option>)}
          </select>
        </div>
        <div className={styles.helpContainer}
            onClick={this.toggleHelp}>
          <div className={`${styles.helpText} font-text`}>{this.props.t('help')}</div>
          <Icon name="Arrow" className={styles.helpArrow} style={arrowStyle}/>
        </div>
        { this.renderLogin() }
      </div>
    );
  }

  render() {
    const lang = getTranslationLang();
    let containerStyle = this.props.isMemorialTheme ? styles.container_memorial : styles.container;
    if (this.state.isDesktop) {
      containerStyle = this.props.isMemorialTheme ? styles.desktopContainer_memorial : styles.desktopContainer;
    }
    return (
      <Fragment>
        {
          this.props.show && <Div100vh className={styles.overlay}
                                       onClick={this.onClosePress} />
        }
        <CSSTransition
          in={this.props.show}
          timeout={400}
          classNames="modalSlideLeft"
          unmountOnExit
          mountOnEnter>
          <Div100vh className={containerStyle}>
            { this.state.isHelpOpened && this.renderHelp() }
            { !this.state.isHelpOpened && this.renderMain() }
          </Div100vh>
        </CSSTransition>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUserInfo: currentUserInfoSelector(state),
    show: sidebarVisibilitySelector(state),
    createState: createLlamaStateSelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    goLogin: () => dispatch(push('/login')),
    setSidebarVisibility: (visible) => dispatch(setSidebarVisibility(visible)),
    updateUserLang: (lang) => dispatch(updateProfileInfo({ lang })),
  }
};

export default compose(
  withTranslation('cmp-sidebar'),
  connect(mapStateToProps, mapDispatchToProps)
)(Sidebar);


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/components/sidebar/index.jsx